function Footer(){
    return(
        <div className='footer-section pt-5'>
        <div className="row">
            <div className="footer-text">Copyright &copy;2024 All rights reserved | Nadeem Ansari</div>
        </div>
    </div>
    );
}
export default Footer;